const Documents = id => `{
  documents(applicantId: "${id}") {
    id
    type
    fileName
    folder
    approvalStatus {
      admin {
        name
        picture
        email
        phone
      }
      date
      type
      message
    }
    uploadedAt
  }
}
`;

export default Documents;



// WEBPACK FOOTER //
// ./src/features/FileHandler/queries.js